// export.ts — CSV export of saved moments (all local; nothing leaves the device).
// Lets the owner keep a copy of the memory book outside the app.

import type { Moment } from "./store";
import { displayPlace } from "./store";

function cell(v: string | number): string {
  const s = String(v ?? "");
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}
function csv(headers: string[], rows: (string | number)[][]): string {
  return [headers, ...rows].map((r) => r.map(cell).join(",")).join("\n");
}

/** Full CSV: Date, Title, Caption, Place, Milestone, Has photo. */
export function momentsCsv(moments: Moment[]): string {
  return csv(
    ["Date", "Title", "Caption", "Place", "Milestone", "Has photo"],
    moments.map((m) => [
      m.happened_on,
      m.title ?? "",
      m.caption ?? "",
      displayPlace(m.place),
      m.is_milestone ? "yes" : "",
      m.photo ? "yes" : "",
    ]),
  );
}

export function buildExport(moments: Moment[]): { csv: string; filename: string } {
  const stamp = new Date().toISOString().slice(0, 10);
  return { csv: momentsCsv(moments), filename: `forever-paw-moments-${stamp}.csv` };
}
